/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class QueryDataItemAPI
 * @hideconstructor
 * @classdesc API class used to access data items of the query
*/
define([
	'../../../../api/DataItemAPI'
], (DataItemAPI) => {
	class QueryDataItemAPI extends DataItemAPI{
		/**
		 * @function QueryDataItemAPI#getProjected
		 * @description Determine whether the data item is projected in the query
		 * @public
		 * @return {Boolean} true if the data item is projected in the query, otherwise false
		 */
		getProjected() {}

		/**
		 * @function QueryDataItemAPI#getProjected
		 * @description Determine whether the data item is projected in the query
		 * @public
		 * @param {Boolean} true if the data item is projected in the query, otherwise false
		 */
		setProjected() {}

		/**
		 * @function QueryDataItemAPI#getCommandList
		 * @description Get the list of query data item commands
		 * @public
		 * @return {QueryDataItemCommand[]} array of query data item commands
		 */
		getCommandList() {}

		/**
		 * @function QueryDataItemAPI#addCommand
		 * @description Add a query command to the data item.
		 * @public
		 * @param {QueryDataItemCommand} command The query data item command
		 */
		addCommand() {}

		/**
		 * @function QueryDataItemAPI#setType
		 * @description set the actual type of the query data item
		 * @public
		 * @return {String} dataItem type
		 */
		setType() {}
	}

	return QueryDataItemAPI;
});
